import type { Rng } from "./types";

/** Mulberry32: small, fast, and the same sequence for the same seed everywhere. */
export function makeRng(seed: number): Rng {
  let a = seed >>> 0;
  const next = () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  const rng: Rng = {
    next,
    int: (min, max) => Math.floor(min + next() * (max - min + 1)),
    float: (min, max) => min + next() * (max - min),
    pick: items => {
      if (items.length === 0) throw new Error("pick from an empty list");
      return items[Math.floor(next() * items.length)]!;
    },
    shuffle: items => {
      const out = items.slice();
      for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(next() * (i + 1));
        [out[i], out[j]] = [out[j]!, out[i]!];
      }
      return out;
    },
    chance: p => next() < p,
  };
  return rng;
}

/** A fresh seed for a new question. */
export function randomSeed(): number {
  return Math.floor(Math.random() * 2 ** 32);
}
